import React, { useState } from "react";
import { useColors } from "../../constants/useColors";
import type { GroupProps } from "../../types";
import { Button, Text, View } from "../../Components/Themed";
import { FlatList, Image } from "react-native";
import { Icons } from "../../Components";

type GroupSelectorProps = {
    active_group?:GroupProps,
    groups:GroupProps[],
    onSelectGroup:(group?:GroupProps) => void
}
const GroupSelector = ({ active_group, groups, onSelectGroup }:GroupSelectorProps) => {
    const Colors = useColors();
    const [ visible, setVisible ] = useState(false);

    const renderGroups = (data:{ item:GroupProps, index:number }) => {
        return (
            <Button 
                transparent 
                style={{ flexDirection:'row', alignItems:'center', padding:10, borderRadius:0, borderBottomWidth:1, borderColor:Colors.borders.light }}
                onPress={() => { setVisible(false); onSelectGroup(data.item) }}
            >
                <Image
                    source={{ uri: data.item.group_image?.url }}
                    style={{ height:40, width:40 }}
                    resizeMode='cover'
                />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>{data.item.name}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{data.item.description}</Text>
                </View>
            </Button>
        )
    }

    return (
        <Button float onPress={() => { setVisible(!visible); onSelectGroup(undefined)}}>
            <View transparent style={{ flexDirection:'row', alignItems:'center' }}>
                <Text style={{ flex:1, marginRight:10 }} theme='h1'>{active_group?.name ?? 'No Group'}</Text>
                <Icons.ChevronIcon direction={visible?'up':'down'} color={Colors.text.h1} size={8} />
            </View>
            {visible ?
            <View transparent style={{ marginTop:20 }}>
            <FlatList
                data={groups}
                key={'group_selector'}
                keyExtractor={item => item.group_id.toString()}
                renderItem={renderGroups}
            />
            </View>
            :<></>}
        </Button>
    )
}

export default GroupSelector